import React from 'react';
import { NavLink } from 'react-router-dom';

export interface IFooterItem {
    id: string;
    label: string;
    href: string;
    icon: string | React.ReactElement; // 이모지 또는 React Element
}

const FooterItem: React.FC<IFooterItem> = ({ label, href, icon }) => {
    const location = window.location;
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab') || 'sos';  // 현재 탭 유지

    return (
        <NavLink
            to={`${href}?tab=${tab}`}  // 기존의 tab 값 유지
            className={({ isActive }) =>
                `
                flex flex-col items-center justify-center 
                px-3 py-2 min-w-[60px]
                rounded-xl
                transition-all duration-300 ease-in-out
                transform hover:scale-110
                relative
                group
                ${
                    isActive 
                        ? 'text-blue-600 bg-blue-50/50 shadow-lg shadow-blue-200/30' 
                        : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50/30'
                }
                `
            }
        >
            {({ isActive }) => (
                <>
                    {/* 활성 상태 배경 효과 */}
                    <div className={`absolute inset-0 rounded-xl transition-all duration-300 
                        ${isActive 
                            ? 'bg-gradient-to-br from-blue-100/60 to-blue-200/40 shadow-inner' 
                            : 'bg-transparent group-hover:bg-gradient-to-br group-hover:from-gray-100/50 group-hover:to-gray-200/30'
                        }`} 
                    />
                    
                    {/* 아이콘 컨테이너 */}
                    <div className={`relative z-10 w-8 h-8 flex items-center justify-center rounded-lg
                        transition-all duration-300 ease-in-out
                        ${isActive 
                            ? 'bg-blue-100/70 shadow-sm' 
                            : 'group-hover:bg-white/50 group-hover:shadow-sm'
                        }`}>
                        {typeof icon === 'string' ? (
                            <span className="text-lg filter drop-shadow-sm transition-all duration-300 group-hover:scale-110">
                                {icon}
                            </span>
                        ) : (
                            <div className="filter drop-shadow-sm transition-all duration-300 group-hover:scale-110">
                                {icon}
                            </div>
                        )}
                    </div>
                    
                    {/* 라벨 */}
                    <span className={`relative z-10 text-xs font-medium mt-1 transition-all duration-300
                        ${isActive ? 'text-blue-700' : 'text-gray-600 group-hover:text-gray-800'}
                        filter drop-shadow-sm
                        `}>
                        {label}
                    </span>
                    
                    {/* 활성 상태 인디케이터 */}
                    <div className={`absolute -bottom-1 left-1/2 transform -translate-x-1/2
                        w-1 h-1 rounded-full
                        transition-all duration-300
                        ${isActive 
                            ? 'bg-blue-500 shadow-lg shadow-blue-300/50 scale-100' 
                            : 'bg-transparent scale-0'
                        }`} 
                    />
                </>
            )}
        </NavLink>
    );
};

export default FooterItem;
